<template>
  <slider-contacts />

  <the-nav />

  <div class="main-wrap">
    <div class="contact-wrap">
      <div class="contact-block-item">
        <div class="contact-block-item-image">
          <img :src="require('@/assets/images/contact1.svg')" alt="" />
        </div>
        <div class="contact-block-item-text">
          <div class="contact-block-item-title">Телеграм канал</div>
          <a href="https://t.me/millionb_club" class="contact-block-item-email" target="_blank">t.me/millionb_club</a>
        </div>
      </div>

      <div class="contact-block-item">
        <div class="contact-block-item-image">
          <img :src="require('@/assets/images/contact2.svg')" alt="" />
        </div>
        <div class="contact-block-item-text">
          <div class="contact-block-item-title">Электронная почта:</div>
          <a href="mailto:support@mln.casino" class="contact-block-item-email">support@mln.casino</a>
        </div>
      </div>

      <div class="contact-block-fl">
        <div class="contact-block-info">
          <span style="font-weight: 500"
            >Служба поддержки клуба МиллионЪ круглосуточно находится в Вашем распоряжении. Мы поможем Вам
            зарегистрироваться, сделать первый депозит, вывести выигрыш удобным для Вас способом, проинформируем о новых
            акционных предложениях и турнирах.</span
          >
          <br /><br />
          Мы всегда рады помочь и ответить на все интересующие Вас вопросы.
          <br /><br />
          Ответы на часто задаваемые вопросы Вы найдете здесь. Можете также связаться с оператором службы поддержки.
          <a href="#" class="contact-block-chat-btn" @click.prevent="support"><span>Онлайн чат</span></a>
        </div>
        <div class="contact-block-form">
          <form action="">
            <div class="contact-block-form-title">Напишите нам</div>
            <div class="contact-block-form-fl">
              <div class="contact-block-form-line">
                <input type="text" name="" class="contact-block-input" placeholder="Ваше имя" />
              </div>
              <div class="contact-block-form-line">
                <input type="text" name="" class="contact-block-input" placeholder="E-mail" />
              </div>
            </div>
            <div class="contact-block-form-line">
              <input type="text" name="" class="contact-block-input" placeholder="Тема письма" />
            </div>
            <div class="contact-block-form-line">
              <textarea name="" class="contact-block-textarea" placeholder="Сообщение"></textarea>
            </div>
            <input type="submit" value="Отправить" class="contact-block-submit" />
          </form>
        </div>
      </div>

      <div class="contact-block-bt">
        <div class="contact-block-bt-name">Владельцем сайта является компания:</div>
        <div class="contact-block-bt-text">
          Crystal Investments Limited, Номер лицензии компании CIL, уполномоченного лицензиара: 5536/JAZ выдана 31
          января 2011 года генерал-губернатором Нидерландских Антильских Островов.
        </div>
      </div>
    </div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import PlayLine from '@/components/PlayLine'
import SliderContacts from '@/components/sliders/SliderContacts'
import TheNav from '@/components/TheNav'
import BonusesLine from '@/components/BonusesLine.vue'
import { Talkme } from '@/components/talkme'

export default {
  name: 'Contact',
  components: { BonusesLine, TheNav, PlayLine, SliderContacts },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    support() {
      Talkme.open()
    },
  },
}
</script>

<style scoped></style>
